import React, {useState,useRef} from 'react';

import { useDispatch } from 'react-redux';

import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';

import {
  TextField,
  Tooltip,
} from '@material-ui/core';


import Swal from 'sweetalert2';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import { sesionExpired } from '../../constants/auth/sesionExpired';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";


import '../../styles/style.scss';
import '../../styles/createContentStyle.scss';
import { createVideos, updateVideo } from '../../actions/videos';
//import { fetchFile } from '@ffmpeg/util';
//import { FFmpeg } from '@ffmpeg/ffmpeg';


const IS_IMAGE = false
//const ffmpeg = new FFmpeg()
export const CreateVideoScreen = (props) => {

  const fileUpdate = props.match.params.id;
  
  const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
  const sessionDifference = timeSessionDifference();

  const dispatch = useDispatch();
  const history = useHistory();

  const [videoName, setVideoName] = useState("")
  const [ file, setFile ] = useState(null);

  const [isSubmitted, setIsSubmitted] = useState(false)
  const [isLoadingForm, setIsLoadingForm] = useState(false);
  const barProgress = useRef(null)

  
  const swalCustomButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn custom-btn',
      cancelButton: 'btn custom-cancel-btn me-3'
    },
    buttonsStyling: false
  });

  /**
   * Cambiar de pagina al realizar una solicitud afirmativa
   * @param {*} result - respuesta de la solicitud
   * @author Kenzo Sashida
   * @version 1.0.0 - Julio 2024
   */
  const getReturnPage = (result) => {
    if (result.isConfirmed) {
      props.history.push('/');
    }
  }

  /**
   * Realiza la cancelación de envio del formulario y regresa a la pagina de contenidos
   * @param { string } response - tipo de cancelación realizada
   * @author Kenzo Sashida
   * @version 1.0.0 - Julio 2024
   */
  const handleCancel = (response) => {

    let responseTitle = '';

    if(response === 'return'){
      responseTitle = 'Regresar';
    } else if(response === 'cancel'){
      responseTitle = 'Cancelar';
    }
    swalCustomButtons.fire({
      title: responseTitle,
      text: "Esta acción eliminará toda información no guardada.",
      icon: 'warning',
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) => {
        getReturnPage(result);
    })
  }
  // const compressedVideo = async(video) =>{

  //   await ffmpeg.load()

  //   ffmpeg.writeFile("input.mp4", await fetchFile(video))
  //   await ffmpeg.exec(["-i","input.mp4", '-c:v', 'libx264', '-crf', '28', 'output.mp4' ])
  //   const data = ffmpeg.readFile("output.mp4")
  //   const videoBlob = new Blob([data.buffer], { type: 'video/mp4' });
  //   return videoBlob
  // }

  /**
   * Recupera el archivo cargado
   * @param {*} target - recupera la información del imput de carga de archivo 
   * @returns 
   * @author Kenzo Sashida
   * @version 1.0.0 - Julio 2024
   */
  const onUploadFileChange = ({ target }) => {
    if (target.files < 1 || !target.validity.valid) {
      return
    } 
    setFile(target.files[0])

  }
  



  /**
   * Envia la información del formulario del formulario para crear o actualizar contenidos
   * @param {*} data - datos del formulario
   * @author Kenzo Sashida
   * @version 1.0.0 - Julio 2024
   */
  const onSubmit = async(e) => {
    e.preventDefault()
     setIsSubmitted(true)
    setIsLoadingForm(true);
    if(fileUpdate){
      getUpdateService();
    } else {
      getCreateService();
    }
  };

  /**
   * Actualiza nombre del video mediante el servicio
   * @author Kenzo Sashida 
   * @version 1.0.0 - Julio 2024
   */
  const getUpdateService = () =>{
    const name = {
      oldName: fileUpdate,
      newName: videoName
    }
    dispatch(updateVideo(name,IS_IMAGE)).then(()=>{
      setIsLoadingForm(false);
      Swal.fire({
        icon: 'success',
        title: 'Contenido actualizado.',
        showConfirmButton: true,
        confirmButtonText: 'Regresar'
      })
      .then((result) => {
          getReturnPage(result);
      });    
    }).catch((error)=>{
      setIsLoadingForm(false);
      if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
        } else{
          actionErrorConnection(error, 'Error al actualizar contenido.');
        }
    });
  }

  /**
   * Funcion para crear videos
   * @author Kenzo Sashida 
   * @version 1.0.0 - Julio 2024
   */
  const getCreateService = () =>{
    const renamedFile = new File([file], videoName)

    dispatch(createVideos(false,renamedFile)).then(()=>{
      Swal.fire({
        icon: 'success',
        title: 'Nuevo contenido creado.',
        showConfirmButton: true,
        confirmButtonText: 'Regresar'
      })
      .then((result) => {
          getReturnPage(result);
         
      }); 
      
    }).catch((error)=>{
      setIsLoadingForm(false);
      if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
        } else{
          actionErrorConnection(error, 'Error al crear contenido.');
        }
    });
  }
  const handleChangeValue = (event)=>{
    setVideoName(event.target.value)
    console.log(videoName)
  }
    return (
        <>
          <div className="container-fluid p-0 m-0">
            <div className="row flex-nowrap p-0 m-0">
                <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
                <SidebarMenu/>
                </div>
                <div className="col p-0 ms-1 me-1">
                <NavTopMenu />


                <div className="container ps-3 pe-3 container-size">
                  <div className="row base-container ">
                    <div className="col-12 border-title text-title pt-2 pb-2 ps-4 h4">
                      <div className="row">
                        <div className="col-10 text-title">
                          <span>Contenido </span>
                          <i className="fas fa-angle-right ms-2 me-2"></i>
                          <span>Videos</span>
                          <i className="fas fa-angle-right ms-2 me-2"></i>
                          <span>{fileUpdate ? 'Actualizar' : 'Nuevo contenido'}</span>
                        </div>
                        <div className="col-2 text-title">
                          <div className="w-100 d-flex justify-content-end">
                            <Tooltip title="Regresar" placement="top-start" arrow>
                              <button className="btn custom-btn-icons" 
                              type="button" 
                              onClick={()=>handleCancel('return')}
                              >
                                <i className="fas fa-angle-left custom-icon-return"></i>
                              </button>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="col-12 pt-3 pb-3 ps-4 pe-4">
                      <form onSubmit={onSubmit}>
                        <div className="container p-0">
                          <div className="row ">
                            <div className="col-md-3">
                              <div className="border-text-menu-title">
                                <span className="text-subtitle" >Información general</span>
                              </div>
                            </div>
                            <div className="col-md-9 pt-5 pb-2">
                              <div className="row">
                                <div className="col-md-6 mt-2 mb-2">
                                <TextField
                                required
                                className="w-100"
                                id="name"
                                name="name"
                                label="Nombre del Video"
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={(event)=>handleChangeValue(event)}
                                size="small"
                              />
                                </div>
                              </div> 
                            </div>
                          </div>
                          {  !fileUpdate &&                     
                          <div className="row ">
                            <div className="col-md-3">
                              <div className="border-text-menu-title">
                                <span className="text-subtitle">Cargar video</span>
                              </div>
                            </div>
                            <div className="col-md-9 pt-5">
                              <div className="row">
                                <div className="col-md-12 mt-2 mb-2 input-group d-flex flex-column">
                                    <>
                                      <input 
                                        type="file" 
                                        name="file" 
                                        id="file"
                                        className="form-control w-100 mb-2"  
                                        accept="video/mp4,video/x-m4v,video/*"
                                        onChange={onUploadFileChange}
                                      /> 
                                    </>                                 
                                  <progress className={`${isSubmitted ? "d-block" : "d-none"}`} ref={barProgress} id="upload-progress" value="0" max="100"></progress>
                                  
                                </div>
                              </div>
                            </div>
                          </div>}
                          <div className="d-flex flex-row-reverse ">
                            <div className="col-md-9 d-flex flex-row-reverse border-button-actions mt-2 pt-2">
                              <button  
                              className="btn custom-btn pt-2 pb-2 ps-3 pe-3" 
                          
                              disabled={fileUpdate ? !videoName : !videoName || !file}>
                                <span className="me-2">{fileUpdate ? 'Actualizar' : 'Agregar'}</span>
                                {
                                    isLoadingForm
                                    ? <i className="fas fa-spinner fa-spin"></i>
                                    : <i className="fas fa-save"></i>
                                } 
                              </button>
                              <button  
                              className="btn custom-cancel-btn pt-2 pb-2 ps-3 pe-3 me-3"
                              type="button" 
                              onClick={()=>handleCancel('cancel')}>
                                    Cancelar
                              </button>
                            </div>
                          </div>
                          
                        </div>
                      </form>
                    </div>
                      
                     
                    
                  </div>
                </div>

                </div>
            </div>
          </div>
        
           
            <Footer/>
        </>
    )
}

CreateVideoScreen.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  }),
  history: PropTypes.object
}
